import es from 'date-fns/locale/es';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { InputText } from 'primereact/inputtext';
import { default as React, useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import * as PROFILE from "../../../constants/profile";
import { useAuth } from '../../../hooks/useAuth';
import { ColumnGroup } from 'primereact/columngroup';

registerLocale('es', es)

function DriverPaymentReport() {

  // #region vars and consts

  const { hasPermission } = useAuth();
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [report, setReport] = useState([]);
  const [reportSubtotal, setReportSubtotal] = useState(null);
  const [reportDetail, setReportDetail] = useState([]);
  const [globalFilter, setGlobalFilter] = useState('');
  const [detailGlobalFilter, setDetailGlobalFilter] = useState('');
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({
    'global': { value: null, matchMode: FilterMatchMode.CONTAINS },    
    'driverName': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },    
    'amountByDriver': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
    'amountByVehicle': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
    'commissionAmount': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
    'commissionPercentage': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },    
    'serviceNoByDriver': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    'serviceNoByVehicle': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    'vehicleNo': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },              
    'pendingPayment': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
  });
  const [detailFilters, setDetailFilters] = useState({
    'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
    'driverName': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    'amountByDriver': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
    'amountByVehicle': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
    'commissionAmount': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
    'commissionPercentage': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
    'serviceNoByDriver': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    'serviceNoByVehicle': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    'vehicleNo': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
  });

  // #endregion

  // #region methods

  const getDriverPaymentReport = (
    startDate,
    endDate
  ) => {
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}/driverReport/generate`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        startDate,
        endDate
      })
    }).then(response => response.json()).then(data => {      
      if (data.responseCode === 'OK') {                
        console.log("Report", data.responseObject);
        setReport(data.responseObject.driverReportOutDto);
        setReportDetail(data.responseObject.driverDetail);
        setReportSubtotal(data.responseObject.subtotal);          
      }
      setLoading(false);
    });
  }

  const scrollToTop = () => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
  }

  const exportAsExcel = () => {
    import('xlsx').then(xlsx => {
      const heading = [[
        'Conductor',
        'No. de Servicios por Conductor',
        'Monto por Conductor',
        'No. de Vehículo',        
        'No. de Servicios por Vehículo',        
        'Monto por Vehículo',
        '% de Comisión',
        'Comisión',
        'Pendiente'
      ]];      
      const worksheet = xlsx.utils.json_to_sheet(report, { origin: 'A2', skipHeader: true });
      xlsx.utils.sheet_add_aoa(worksheet, heading, { origin: 'A1' });
      const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
      const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
      const fileName = 'ReportePorOperador';
      import('file-saver').then(module => {
        if (module && module.default) {
          let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
          let EXCEL_EXTENSION = '.xlsx';
          const data = new Blob([excelBuffer], {
            type: EXCEL_TYPE
          });
          module.default.saveAs(data, fileName + '_' + new Date().getTime() + EXCEL_EXTENSION);
        }
      });
    });
  };


  const exportDetailAsExcel = () => {
    import('xlsx').then(xlsx => {
      const heading = [[
        'Conductor',
        'No. de Servicios por Conductor',
        'Monto por Conductor',
        'No. de Vehículo',
        'No. de Servicios por Vehículo',
        'Monto por Vehículo',
        '% de Comisión',
        'Comisión',
      ]];
      const worksheet = xlsx.utils.json_to_sheet(reportDetail, { origin: 'A2', skipHeader: true });
      xlsx.utils.sheet_add_aoa(worksheet, heading, { origin: 'A1' });
      const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
      const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
      const fileName = 'ReportePorOperadorDetalle';
      import('file-saver').then(module => {
        if (module && module.default) {
          let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
          let EXCEL_EXTENSION = '.xlsx';
          const data = new Blob([excelBuffer], {
            type: EXCEL_TYPE
          });
          module.default.saveAs(data, fileName + '_' + new Date().getTime() + EXCEL_EXTENSION);
        }
      });
    });
  };

  // #endregion

  // #region events

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };
    _filters['global'].value = value;
    setFilters(_filters);
    setGlobalFilter(value);
  };

  const onDetailGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...detailFilters };
    _filters['global'].value = value;
    setDetailFilters(_filters);
    setDetailGlobalFilter(value);
  };

  const onSearchButtonPress = () => {
    setReport([]);
    getDriverPaymentReport(
      startDate.valueOf(),
      endDate.valueOf()
    );
  }

  const onExportExcelButtonPress = () => {
    exportAsExcel();
  };
  
  const onExportDetailExcelButtonPress = () => {
    exportDetailAsExcel();
  };

  useEffect(() => {
    scrollToTop();
  }, []);

  // #endregion

  // #region templates

  const filtersTemplate = (
    <>
      <Row>
        <Col md={4}>
          <Form.Group className="mb-3">
            <Form.Label>
              Fecha inicial
            </Form.Label>
            <DatePicker
              controlId="startDateInput"
              dateFormat="dd/MMM/yyyy"
              selected={startDate}
              onChange={(date) => setStartDate(date)}
              selectsStart
              startDate={startDate}
              endDate={endDate}
              locale="es"
              className="w-100 app_datepicker" />
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group className="mb-3">
            <Form.Label>
              Fecha final
            </Form.Label>
            <DatePicker
              controlId="endDateInput"
              dateFormat="dd/MMM/yyyy"
              selected={endDate}
              onChange={(date) => setEndDate(date)}
              selectsEnd
              startDate={startDate}
              endDate={endDate}
              minDate={startDate}
              locale="es"
              className="w-100 app_datepicker" />
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col>
          <Button
            type="button"
            icon="pi pi-search"
            onClick={onSearchButtonPress}
            className="p-button-raised p-button-sm p-button-primary"
            label='Buscar' />
        </Col>
      </Row>
    </>
  );

  const reportHeaderTemplate = (
    <>
      <Row>
        <Col>
          <span className="p-input-icon-left">
            <i className="pi pi-filter" />
            <InputText value={globalFilter} onChange={onGlobalFilterChange} placeholder="Filtrar" className='p-inputtext-sm' />
          </span>
        </Col>
        <Col>
          {
            hasPermission(PROFILE.PERMISSIONS.DOWNLOAD_REPORTS) && (
              <Button type="button" icon="pi pi-file-excel" onClick={onExportExcelButtonPress} className="p-button-raised p-button-sm p-button-success mr-2 float-end" data-pr-tooltip="XLS" label='Exportar' />
            )
          }
        </Col>
      </Row>
    </>
  );

  let footerGroup = (
    <ColumnGroup>
      <Row>
        <Column footer="Subtotal:" footerStyle={{ textAlign: 'right' }} />        
        <Column footer={reportSubtotal ? reportSubtotal.serviceNoTotal : 0} className='text-end' />
        <Column footer={reportSubtotal ? reportSubtotal.amountByDriverTotal.toFixed(2) : 0.00} className='text-end' />        
        <Column footer="" />        
        <Column footer="" />        
        <Column footer="" />        
        <Column footer="" />        
        <Column footer={reportSubtotal ? reportSubtotal.commissionTotal.toFixed(2) : 0.00} className='text-end' />
        <Column footer="" />  
      </Row>
    </ColumnGroup>
  );  

  const amountByDriverColumnTemplate = (rowData) => {
    return rowData.amountByDriver.toFixed(2);
  };

  const amountByVehicleColumnTemplate = (rowData) => {
    return rowData.amountByVehicle.toFixed(2);
  };
  
  const commissionAmountColumnTemplate = (rowData) => {
    return rowData.commissionAmount.toFixed(2);
  };

  const reportByDriverTemplate = (
    <>
      <div>
        <div className="card">
          <DataTable
            value={report}
            paginator
            className="p-datatable-customers"
            showGridlines
            stripedRows
            header={reportHeaderTemplate}
            rows={50}
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            rowsPerPageOptions={[10, 25, 50]}
            filters={filters}
            filterDisplay="menu"
            loading={loading}
            responsiveLayout="scroll"
            globalFilterFields={[              
              'driverName',
              'amountByDriver',
              'amountByVehicle',
              'commissionAmount',
              'commissionPercentage',
              'serviceNoByDriver',
              'serviceNoByVehicle',
              'vehicleNo', ,
              'pendingPayment'
            ]}
            emptyMessage="No records found."
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"       
            footerColumnGroup={footerGroup}
          >
            <Column field="driverName" header="Conductor" sortable filter filterPlaceholder="Buscar por Conductor" className='app-w-150-px text-start' />
            <Column field="serviceNoByDriver" header="No. de Servicios por Conductor" sortable filter filterPlaceholder="Buscar por No. de Servicios por Conductor" className='app-w-50-px text-end' />
            <Column field="amountByDriver" header="Monto por Conductor" sortable filter filterPlaceholder="Buscar por Monto por Conductor" className='app-w-50-px text-end' body={amountByDriverColumnTemplate} />
            <Column field="vehicleNo" header="No. de Vehículo" sortable filter filterPlaceholder="Buscar por No. de Vehículo" className='app-w-50-px text-end' />
            <Column field="serviceNoByVehicle" header="No. de Servicios por Vehículo" sortable filter filterPlaceholder="Buscar por No. de Servicios por Vehículo" className='app-w-50-px text-end' />            
            <Column field="amountByVehicle" header="Monto por Vehículo" sortable filter filterPlaceholder="Buscar por Monto por Vehículo" className='app-w-50-px text-end' body={amountByVehicleColumnTemplate} />
            <Column field="commissionPercentage" header="% de Comisión" sortable filter filterPlaceholder="Buscar por Porcentaje de Comisión" className='app-w-50-px text-end' />
            <Column field="commissionAmount" header="Comisión" sortable filter filterPlaceholder="Buscar por Comisión" className='app-w-50-px text-end' body={commissionAmountColumnTemplate} />            
            <Column field="pendingPayment" header="Pendiente" sortable filter filterPlaceholder="Buscar por Pendiente" className='app-w-150-px text-end' />
          </DataTable>
        </div>
      </div>
    </>
  );

  const reportDetailHeaderTemplate = (
    <>
      <Row>
        <Col>
          <span className="p-input-icon-left">
            <i className="pi pi-filter" />
            <InputText value={detailGlobalFilter} onChange={onDetailGlobalFilterChange} placeholder="Filtrar" className='p-inputtext-sm' />
          </span>
        </Col>
        <Col>
          {
            hasPermission(PROFILE.PERMISSIONS.DOWNLOAD_REPORTS) && (
              <Button type="button" icon="pi pi-file-excel" onClick={onExportDetailExcelButtonPress} className="p-button-raised p-button-sm p-button-success mr-2 float-end" data-pr-tooltip="XLS" label='Exportar' />
            )
          }
        </Col>
      </Row>
    </>
  );

  const reportDetailTemplate = (
    <>
      <div>
        <div className="card">
          <DataTable
            value={reportDetail}
            paginator
            className="p-datatable-customers"
            showGridlines
            stripedRows
            header={reportDetailHeaderTemplate}
            rows={50}
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            rowsPerPageOptions={[10, 25, 50]}
            filters={detailFilters}
            filterDisplay="menu"
            loading={loading}
            responsiveLayout="scroll"
            globalFilterFields={[
              'driverName',
              'amountByDriver',
              'amountByVehicle',
              'commissionAmount',
              'commissionPercentage',
              'serviceNoByDriver',
              'serviceNoByVehicle',
              'vehicleNo'
            ]}
            emptyMessage="No records found."
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"            
          >
            <Column field="driverName" header="Conductor" sortable filter filterPlaceholder="Buscar por Conductor" className='app-w-150-px text-start' />
            <Column field="serviceNoByDriver" header="No. de Servicios por Conductor" sortable filter filterPlaceholder="Buscar por No. de Servicios por Conductor" className='app-w-50-px text-end' />
            <Column field="amountByDriver" header="Monto por Conductor" sortable filter filterPlaceholder="Buscar por Monto por Conductor" className='app-w-50-px text-end' body={amountByDriverColumnTemplate} />
            <Column field="vehicleNo" header="No. de Vehículo" sortable filter filterPlaceholder="Buscar por No. de Vehículo" className='app-w-50-px text-end' />
            <Column field="serviceNoByVehicle" header="No. de Servicios por Vehículo" sortable filter filterPlaceholder="Buscar por No. de Servicios por Vehículo" className='app-w-50-px text-end' />
            <Column field="amountByVehicle" header="Monto por Vehículo" sortable filter filterPlaceholder="Buscar por Monto por Vehículo" className='app-w-50-px text-end' body={amountByVehicleColumnTemplate} />
            <Column field="commissionPercentage" header="% de Comisión" sortable filter filterPlaceholder="Buscar por Porcentaje de Comisión" className='app-w-50-px text-end' />
            <Column field="commissionAmount" header="Comisión" sortable filter filterPlaceholder="Buscar por Comisión" className='app-w-50-px text-end' body={commissionAmountColumnTemplate} />            
          </DataTable>
        </div>
      </div>
    </>
  );

  const reportTemplate = (
    <>
      <article>
        <Row>
          <Col>
            <h1 className='app-font'>
              Reporte por operador
            </h1>
          </Col>
        </Row>
        <Row>
          <Col>
            {filtersTemplate}
          </Col>
        </Row>
        <Row className='pt-2'>
          <Col>
            {reportByDriverTemplate}
          </Col>
        </Row>
        {/* 
        <Row className='pt-2'>
          <Col>
            <h3>Detalle</h3>
          </Col>
        </Row>
        <Row className='pt-2'>
          <Col>
            {reportDetailTemplate}
          </Col>
        </Row> 
        */}
      </article>
    </>
  );

  // #endregion

  return (
    <>
      {reportTemplate}
    </>
  );
}

export default DriverPaymentReport;